module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/carousel_01@2x.faeb27f.png";